import React from "react";
import "./styles.css";

function Footer() {
  return (
 <div></div>
  );
}

export default Footer;
